module.exports = __webpack_public_path__ + "static/img/sc.b9ee541.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/sc.png
// module id = AMY3
// module chunks = 21